import { getRefreshToken } from "@/utils/sessionToken";
import { ConvertedContext } from "@/types/api-interface/user";
import { get, post } from "../request-manager";

export function getToken(ticket: string): Promise<any> {
  return get("/gas/api/v1alpha1/sso/token?ticket=" + ticket + "&legacy=true", {
    withCredentials: true,
  });
}

export function getTenantsInfo(): Promise<ResponseData<ConvertedContext>> {
  return post(`/cedar/v1/context/get`, {});
}

export function refreshAccessToken() {
  return post("/gas/api/v1alpha1/auth/token", {
    refreshToken: getRefreshToken(),
  });
}
